import React from "react";
import { ReviewSummary } from "../review-summary/ReviewSummary";
import { SelectNotices } from "../select-notices/SelectNotices";
import { SelectImages } from "../select-images/SelectImages";
import { AddAttachments } from "../add-attachments/AddAttachments";
import { DownloadPackage } from "../download-package/DownloadPackage";
import { StepRendererProps } from "./types";

export const StepRenderer: React.FC<StepRendererProps> = ({
    currentStep,
    handleStepChange,
    data,
    pdfBlob,
    setPdfBlob,
}) => {
    switch (currentStep) {
        case 0:
            return <ReviewSummary onNext={() => handleStepChange(1)} data={data} />;
        case 1:
            return (
                <SelectNotices
                    onNext={() => handleStepChange(2)}
                    onPrevious={() => handleStepChange(0)}
                    valueNotices={
                        data.appealDetails.appealApproachCalculationData.exportAppealsPackage
                            .valueNotices
                    }
                    data={data}
                />
            );
        case 2:
            return (
                <SelectImages
                    onNext={() => handleStepChange(3)}
                    onPrevious={() => handleStepChange(1)}
                    data={data}
                />
            );
        case 3:
            return (
                <AddAttachments
                    onNext={(blob: Blob) => {
                        setPdfBlob(blob);
                        handleStepChange(4);
                    }}
                    onPrevious={() => handleStepChange(2)}
                    data={data}
                />
            );
        case 4:
            return (
                <DownloadPackage
                    onPrevious={() => handleStepChange(3)}
                    data={data}
                    pdfBlob={pdfBlob}
                />
            );
        default:
            return null;
    }
};
